// timeUtils.js
/**
 * Format stored Peru arrival time to HH:MM.
 */
export function formatArrivalTime(arrivalTime) {
  if (!arrivalTime) return '';
  
  const date = new Date(arrivalTime);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${hours}:${minutes}`;
}
